import { cva } from 'class-variance-authority';

import { cn } from '@heidi/utils';
import { focusRing } from '../styles/focus-ring';
import { typographyVariant } from '../typography';

export const textareaVariants = cva(
  cn(
    typographyVariant({ variant: 'p2' }),
    'flex min-h-[80px] w-full rounded-lg border border-border bg-surface px-3 py-2 placeholder:text-text-secondary disabled:cursor-not-allowed disabled:bg-surface-disabled disabled:text-text-disabled disabled:placeholder:text-text-disabled',
    focusRing
  )
);

// Extra styling for the manually-resizable textarea: hides the native webkit
// resizer (the custom handle in `Textarea` replaces it).
export const textareaResizableClasses = '[&::-webkit-resizer]:hidden';
